import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=586f133d&scoped=true&"
var script = {}
import style0 from "./Resource.vue?vue&type=style&index=0&id=586f133d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f133d",
  null
  
)

export default component.exports